import { isPublicProjectPathname } from '@shared/constants/router.constants';

/**
 * Whether GET /element-imports should run for this project on the current URL.
 * Public `/generation` and `/shared/.../v/...` routes send a shared-project
 * Organization header, so org-scoped project lookup 404s.
 */
export const shouldLoadElementImports = (
  projectId: number,
  pathname: string,
): boolean => projectId > 0 && !isPublicProjectPathname(pathname);
